// Wrapper file to export all reporting control...EK
import image from './reportImage';
import label from './reportLabel';
import pageBreak from './reportPageBreak';
import pageInfo from './reportPageInfo';
import tableRow from './reportTableRow';
import subReport from './reportSub';
import {ReportLine} from './reportLine';
import {ReportControlGroup} from './reportControlGroup';

export default {
    image: image,
    label: label,
    pageBreak: pageBreak,
    pageInfo: pageInfo, pageinfo: pageInfo,     //NOTE: I updated the naming convention to implement proper casing for types.  The duplicate is here for legacy support..EK
    tableRow: tableRow,
    subReport: subReport,
    line: new ReportLine(),
    controlGroup: new ReportControlGroup()
};